export class Task {
    questions=[]
    providedAbilities=[]
    requiredAbilities=[]
    name=""
    answerTemplateName=""
    server_answer_template_id=0
    description=""
    disable_quiz_count=0
    server_task_template_id=0
    id=0
}
